import React, { useEffect, useState } from "react";
import copy from "copy-to-clipboard";
import Context from "../../context";

export default function ReferralModal({ onClose }: { onClose: () => void }) {
  const { userInfo } = React.useContext(Context);
  const [referralCode, setReferralCode] = useState("");
  const [bonusBalance, setBonusBalance] = useState(0);
  const [wagerRequired, setWagerRequired] = useState(0);
  const [copied, setCopied] = useState(false);
  const [loading, setLoading] = useState(true);

  const referralLink = `https://play.avitex.online?ref=${referralCode}`;

  useEffect(() => {
    const token = localStorage.getItem("aviator-token");
    if (!token) { setLoading(false); return; }
    fetch("/api/my-referral", { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json())
      .then(data => {
        if (data.status) {
          setReferralCode(data.referralCode || "");
          setBonusBalance(data.bonusBalance || 0);
          setWagerRequired(data.wagerRequired || 0);
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const handleCopy = (text: string) => {
    copy(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const overlay: React.CSSProperties = {
    position: "fixed", inset: 0, background: "rgba(0,0,0,0.85)",
    zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center"
  };
  const modal: React.CSSProperties = {
    background: "#1a1a2e", border: "1px solid #333", borderRadius: "12px",
    padding: "28px", width: "360px", maxHeight: "90vh", overflowY: "auto",
    boxShadow: "0 20px 60px rgba(0,0,0,0.6)"
  };

  return (
    <div style={overlay}>
      <div style={modal}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
          <h3 style={{ color: "#fff", margin: 0, fontSize: "18px" }}>🎁 Referral Program</h3>
          <button onClick={onClose} style={{ background: "none", border: "none", color: "#aaa", fontSize: "24px", cursor: "pointer" }}>×</button>
        </div>

        {/* How it works */}
        <div style={{ background: "#0d1117", borderRadius: "8px", padding: "14px", marginBottom: "20px" }}>
          <p style={{ color: "#ff6a00", fontSize: "13px", fontWeight: "bold", margin: "0 0 8px" }}>How it works</p>
          <p style={{ color: "#aaa", fontSize: "12px", margin: "0 0 6px" }}>✅ Share your referral link with friends</p>
          <p style={{ color: "#aaa", fontSize: "12px", margin: "0 0 6px" }}>✅ Friend registers & makes first deposit</p>
          <p style={{ color: "#aaa", fontSize: "12px", margin: 0 }}>✅ <strong style={{ color: "#4caf50" }}>Both get KSh 200 bonus!</strong> (unlock by wagering KSh 1,000)</p>
        </div>

        {loading ? (
          <p style={{ color: "#aaa", textAlign: "center" }}>Loading...</p>
        ) : (
          <>
            {/* Referral Code */}
            <div style={{ marginBottom: "16px" }}>
              <label style={{ color: "#aaa", fontSize: "12px", display: "block", marginBottom: "6px" }}>Your Referral Code</label>
              <div style={{ display: "flex", gap: "8px" }}>
                <div style={{ flex: 1, background: "#2a2a3e", border: "1px solid #444", borderRadius: "6px", padding: "10px 12px", color: "#fff", fontSize: "16px", fontWeight: "bold", letterSpacing: "2px" }}>
                  {referralCode || "—"}
                </div>
                <button onClick={() => handleCopy(referralCode)}
                  style={{ background: "#ff4500", border: "none", borderRadius: "6px", padding: "10px 14px", color: "#fff", cursor: "pointer", fontSize: "12px", fontWeight: "bold" }}>
                  {copied ? "✓" : "Copy"}
                </button>
              </div>
            </div>

            {/* Referral Link */}
            <div style={{ marginBottom: "20px" }}>
              <label style={{ color: "#aaa", fontSize: "12px", display: "block", marginBottom: "6px" }}>Share this link</label>
              <div style={{ display: "flex", gap: "8px" }}>
                <div style={{ flex: 1, background: "#2a2a3e", border: "1px solid #444", borderRadius: "6px", padding: "10px 12px", color: "#666", fontSize: "11px", wordBreak: "break-all" }}>
                  {referralLink}
                </div>
                <button onClick={() => handleCopy(referralLink)}
                  style={{ background: "#2a2a3e", border: "1px solid #555", borderRadius: "6px", padding: "10px 14px", color: "#fff", cursor: "pointer", fontSize: "12px" }}>
                  📋
                </button>
              </div>
            </div>

            {/* Bonus Progress */}
            {bonusBalance > 0 && (
              <div style={{ background: "#0d1117", borderRadius: "8px", padding: "14px" }}>
                <p style={{ color: "#ff6a00", fontSize: "13px", fontWeight: "bold", margin: "0 0 10px" }}>🔒 Bonus Balance</p>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "6px" }}>
                  <span style={{ color: "#aaa", fontSize: "12px" }}>Locked bonus</span>
                  <span style={{ color: "#4caf50", fontWeight: "bold" }}>KSh {bonusBalance.toFixed(2)}</span>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
                  <span style={{ color: "#aaa", fontSize: "12px" }}>Still to wager</span>
                  <span style={{ color: "#ff4444", fontWeight: "bold" }}>KSh {wagerRequired.toFixed(2)}</span>
                </div>
                <div style={{ background: "#333", borderRadius: "4px", height: "6px" }}>
                  <div style={{
                    background: "#ff6a00", borderRadius: "4px", height: "6px",
                    width: `${Math.min(100, ((bonusBalance * 5 - wagerRequired) / (bonusBalance * 5)) * 100)}%`,
                    transition: "width 0.3s"
                  }} />
                </div>
                <p style={{ color: "#666", fontSize: "11px", marginTop: "8px", marginBottom: 0 }}>
                  Keep playing to unlock your bonus!
                </p>
              </div>
            )}

            {bonusBalance === 0 && wagerRequired === 0 && (
              <p style={{ color: "#666", fontSize: "12px", textAlign: "center" }}>
                No active bonus. Share your link to earn KSh 200!
              </p>
            )}
          </>
        )}
      </div>
    </div>
  );
}
